// New data structure for 3-book series
export const booksData = {
  bundle: {
    title: "Complete Marriage 101 Series",
    price: 2500,
    originalPrice: 4000,
    discount: "Save ₹1,500",
    description: "Get all 3 essential books for building a strong, lasting marriage",
    books: ["right-partner", "great-sex", "balanced-family"]
  },
  
  individual: {
    "right-partner": {
      id: "right-partner",
      title: "Right Partner 101",
      subtitle: "Choosing Right Partner with Astrology",
      price: 500,
      coverImage: "https://customer-assets.emergentagent.com/job_hindu-marriage-guide/artifacts/qxakht9c_Righ%20Partner%20101%20Cover%20Page.JPG",
      pdfUrl: "https://customer-assets.emergentagent.com/job_hindu-marriage-guide/artifacts/bb80omhb_Right%20Partner%20101.pdf",
      previewPdfPath: "/api/preview/right-partner",
      keyAreas: [
        "Understanding Yourself Before Choosing a Life Partner",
        "How to Choose the Right, Truly Compatible Partner",
        "Rashi, Nakshatra & Gana - Explained in Simple Terms", 
        "Compatible vs Non-Compatible Rashis, Nakshatras & Ganas",
        "Most Common (and Costly) Mistakes in Partner Selection"
      ],
      description: "A practical guide to finding a compatible life partner using both modern psychology and traditional wisdom."
    },
    
    "great-sex": {
      id: "great-sex", 
      title: "Great Sex 101",
      subtitle: "Proven Methods to Improve Sexual Experience",
      price: 1500,
      coverImage: "https://customer-assets.emergentagent.com/job_hindu-marriage-guide/artifacts/ccz5iov6_Great%20Sex%20101%20Cover%20Page.JPG",
      pdfUrl: "https://customer-assets.emergentagent.com/job_hindu-marriage-guide/artifacts/hqvrh942_Great%20Sex%20101.pdf",
      previewPdfPath: "/api/preview/great-sex",
      keyAreas: [
        "Understanding Sexual Experience in Men & Women",
        "Erectile Dysfunction - Practical, Everyday Solutions",
        "Premature Ejaculation - Learn Proven Methods to Improve Control",
        "Female Arousal - Understanding Desire & Effective Foreplay",
        "Genital Infections - Simple Hygiene Practices Everyone Should Follow",
        "Yoga Asanas & Breathing Techniques for Better Performance",
        "Supporting Each Other in the Sexual Journey"
      ],
      description: "Educational guidance for building deeper intimacy and addressing common concerns in married life."
    },
    
    "balanced-family": {
      id: "balanced-family",
      title: "Balanced Family 101", 
      subtitle: "Planning a balanced family with both a son and a daughter",
      price: 2000,
      coverImage: "https://customer-assets.emergentagent.com/job_hindu-marriage-guide/artifacts/b9v5aeqi_Balanced%20Family%20101%20Cover%20Page.JPG",
      pdfUrl: "",
      previewPdfPath: "/api/preview/balanced-family",
      keyAreas: [
        "Conscious & Responsible Family Planning",
        "Cultural Beliefs vs Biological Facts",
        "Understanding the Fertilization Process",
        "Ways to plan for a Baby Boy",
        "Ways to plan for a Baby Girl"
      ],
      description: "Thoughtful guidance on family planning decisions with cultural sensitivity and scientific understanding."
    }
  },
  
  heroSection: {
    headline: "Marriage is not a Netflix subscription you can cancel anytime — it's a lifelong commitment.",
    subheadline: "This series helps you think clearly about marriage—before and after the wedding.",
    outcomePoints: [
      "Learn how to choose a truly compatible life partner",
      "Upgrade your sexual experience with practical, real-world guidance", 
      "Plan a balanced family with a girl & boy - with clarity and confidence",
      "Only practical solutions. No myths. No fluff."
    ]
  },
  
  supportInfo: {
    whatsappNumber: "8977923805",
    domain: "www.marriage101.in",
    email: "support@marriage101.in"
  }
};

// Mobile number gate data
export const mobileGateData = {
  headline: "Before you continue",
  description: "This content is meant for serious readers who want to make informed decisions about marriage and relationships.",
  subDescription: "Enter your mobile number to receive a free sample chapter and continue.",
  ctaText: "Send Me the Free Sample",
  trustLine: "No spam. No promotional calls.",
  trustSubLine: "You will receive only the sample and essential updates related to this content."
};

// Razorpay configuration - key is fetched from backend API
// Do not hardcode keys here - they come from the payment/create-order response
export const razorpayConfig = {
  // Key will be provided by backend API response (order.key_id)
};